export const plugins = [{
    plugin: require('bernie-plugin-isomorphic-logger/dist/browser'),
    options: JSON.parse('{}')
  },{
    plugin: require('bernie-plugin-context/dist/browser'),
    options: JSON.parse('{"enablePlatformContextProvider":true}')
  },{
    plugin: require('bernie-plugin-mobx/dist/browser'),
    options: JSON.parse('{}')
  },{
    plugin: require('bernie-plugin-experiment-store/dist/browser'),
    options: JSON.parse('{"egtnlEnabled":true}')
  },{
    plugin: require('bernie-plugin-apollo/dist/browser'),
    options: JSON.parse('{"serverTimeout":30000,"browserTimeout":30000,"usePossibleTypes":true}')
  },{
    plugin: require('bernie-plugin-global-components-context/dist/browser'),
    options: JSON.parse('{}')
  },{
    plugin: require('bernie-plugin-clickstream/dist/browser'),
    options: JSON.parse('{"brandClickstream":"uis-prime"}')
  },{
    plugin: require('bernie-plugin-egds-styles/dist/browser'),
    options: JSON.parse('{}')
  },{
    plugin: require('bernie-plugin-ads-loader-script/dist/browser'),
    options: JSON.parse('{"serverTimeout":30000}')
  },{
    plugin: require('bernie-plugin-datadog-rum/dist/browser'),
    options: JSON.parse('{"enabled":true,"applicationId":"de682816-8959-4c56-8e75-7fae734ddd25","clientToken":"pub4a493894eab7c945b7d756789703065e","datadogSite":"datadoghq.com","sampleRate":10,"service":"bernie-cars-shopping-web","trackInteractions":true,"defaultPrivacyLevel":"mask-user-input","trackViewsManually":true,"trackFrustrations":true}')
  }]